<div
  #wrapperEl
  class="gx-combo"
  [class.is-open]="isOpen()"
  [class.is-disabled]="isEffectivelyDisabled()">
  <i [class]="ICONS.magnifyingGlass" class="text-text-tertiary shrink-0 text-sm"></i>
  <input
    type="text"
    class="text-text-primary placeholder:text-text-tertiary min-w-0 flex-1 border-none bg-transparent font-sans text-[13px] outline-none"
    [id]="id()"
    [value]="searchText()"
    [placeholder]="placeholder() ?? ''"
    [disabled]="isEffectivelyDisabled()"
    (input)="onSearchInput($event)"
    (keydown)="onKeyDown($event)"
    (focus)="onInputFocus()" />
  @if (searchText().length > 0 && !isEffectivelyDisabled()) {
    <i
      [class]="ICONS.x"
      class="text-text-tertiary hover:text-text-primary shrink-0 cursor-pointer text-sm"
      role="button"
      tabindex="-1"
      [attr.aria-label]="'common.clear' | translate"
      (click)="clear()"
      (keydown.enter)="clear()"></i>
  }
</div>

<ng-template #panel>
  <div class="g-menu">
    <div class="g-menu-scroll">
      @for (option of filteredOptions(); track option; let i = $index) {
        <div
          class="g-menu-item"
          role="button"
          tabindex="-1"
          [class.is-focused]="i === highlightedIndex()"
          (click)="selectOption(option)"
          (keydown.enter)="selectOption(option)">
          <span class="ellipsis">
            <app-highlighted-match [text]="option" [term]="searchText()" />
          </span>
        </div>
      }
    </div>
  </div>
</ng-template>

<app-dropdown
  [target]="wrapper().nativeElement"
  [template]="panel"
  [isOpen]="isOpen()"
  [onClose]="close"
  [useDefaultStyles]="false"
  [offset]="4"
  [minWidth]="wrapperWidth()" />
